
import { Vue, Component, Prop } from "vue-property-decorator";
// Entities
import { Company, Profile } from "@/entities/index";
// Services
import { getRealStockVSPrev } from "@/services";

@Component
export default class Chart3 extends Vue {
  @Prop() readonly warehouseCode!: string;
  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  integrateStepZero = this.company.integrateStepZero;

  stockRealVsPrev: unknown[] = [];
  months: string[] = [];

  get optionsStockRealVsPrev(): unknown {
    return {
      xaxis: {
        categories: this.months.map((x: any) => this.$t(`months.${x}`)),
      },
      chart: {
        type: "bar",
        height: 250,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: "12px",
          colors: ["#fff"],
        },
      },
      stroke: {
        show: true,
        width: 1,
        colors: ["#fff"],
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      colors: ["#154077", "#aabb00"],
    };
  }

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  async loadRealStockVSPrev(): Promise<void> {
    const { realStock, realStockPrev, month } = await getRealStockVSPrev({
      client: this.client,
      warehouse: this.warehouseCode,
      integrateStepZero: this.integrateStepZero,
    });
    this.stockRealVsPrev = [
      {
        name: this.$t("dataDashboard.charts.chart3.realStock"),
        data: realStock,
      },
      {
        name: this.$t("dataDashboard.charts.chart3.prevStock"),
        data: realStockPrev,
      },
    ];
    this.months = month;
  }
}
